import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acceso-denegado',
  templateUrl: './acceso-denegado.component.html',
  styleUrls: ['./acceso-denegado.component.css']
})
export class AccesoDenegadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  redirectToLogin(): void {
    window.location.href = '/login';
  }  
}
